/** Prošireni SEO i sadržaj po usluzi — spaja se u getServiceBySlug */
export const SERVICE_DETAILS = {
  "hotelska-posteljina-jastuci": {
    breadcrumb: "Hotelska posteljina",
    seoIntro:
      "TOP WASH DOO pruža profesionalno pranje hotelske posteljine u Beogradu za hotele, apartmane, hostele i pansione. Industrijski kapacitet, kontrolisana belina, fiksni raspored preuzimanja i isporuke — bez skrivenih troškova i bez kompromisa u kvalitetu koji gost očekuje.",
    targets: ["Hoteli", "Apartmani", "Hosteli", "Pansioni", "Apart-hotel"],
    inventory: [
      "Platneni i satenski čaršavi",
      "Jastučnice i navlake",
      "Navlake za jorgane",
      "Prekrivači i dekorativni tekstil",
      "Beli i obojeni program odvojeno",
    ],
    highlights: [
      { label: "Rok obrade", value: "24 – 48h" },
      { label: "Zona", value: "Beograd" },
      { label: "Model", value: "B2B ugovor" },
    ],
    localSeo:
      "Uslugu pranja hotelske posteljine pružamo u celom Beogradu — Novi Beograd, Zemun, Vračar, Zvezdara, Voždovac, Čukarica i okolina. Sjedište firme je u Rakovici, sa optimizovanom logistikom preuzimanja i dostave za smeštajne objekte svih veličina.",
    process: [
      { step: "01", title: "Procena inventara", desc: "Obilazak ili online procena obima i tipa posteljine." },
      { step: "02", title: "Preuzimanje", desc: "Fiksni termin — prljav veš ide u zatvorenom transportu." },
      { step: "03", title: "Pranje i peglanje", desc: "Kontrola temperature, pH i beline po tipu tkanine." },
      { step: "04", title: "Isporuka", desc: "Čista posteljina spremna za postavljanje u sobu." },
    ],
    extraFaq: [
      {
        q: "Da li radite sa Airbnb i kratkoročnim apartmanima?",
        a: "Da. Prilagođavamo dinamiku preuzimanja broju rezervacija i rotaciji soba — idealno za apartmane sa čestom smenom gostiju.",
      },
      {
        q: "Kako se štiti belina belog veša?",
        a: "Beli program peremo odvojeno od obojenog, uz programe i sredstva koja održavaju belinu i produžavaju vek trajanja tkanine.",
      },
    ],
  },
  "stolnjaci-salvete": {
    breadcrumb: "Stolnjaci i salvete",
    seoIntro:
      "Profesionalno pranje stolnjaka i salveti za restorane, kafiće, svečane sale i catering u Beogradu. TOP WASH DOO garantuje peglanje po standardu, uklanjanje mrlja od hrane i pića, te isporuku tekstila spremnog za sto pre svake smene.",
    targets: ["Restorani", "Kafići", "Svečane sale", "Catering", "Hotelski restorani"],
    inventory: [
      "Beli i obojeni stolnjaci",
      "Damast i platnene salvete",
      "Overlejs i prostirke",
      "Runners za bankete",
      "Podne prostirke za sto",
    ],
    highlights: [
      { label: "Peglanje", value: "Uključeno" },
      { label: "Rok", value: "24 – 48h" },
      { label: "Obim", value: "Fleksibilan" },
    ],
    localSeo:
      "Pranje stolnjaka i salveti dostupno je restoranima i kafićima širom Beograda — od centra grada do poslovnih zona i hotela na Novom Beogradu. Organizujemo preuzimanje pre otvaranja ili posle zatvaranja, u skladu sa vašim smenama.",
    process: [
      { step: "01", title: "Katalog tekstila", desc: "Definišemo tipove, boje i količine po stolu i smeni." },
      { step: "02", title: "Preuzimanje", desc: "Prijem prljavog tekstila po dogovorenom rasporedu." },
      { step: "03", title: "Pranje i peglanje", desc: "Tretman mrlja, sortiranje po boji i ivicama." },
      { step: "04", title: "Pakovanje", desc: "Spremno za postavljanje na sto — sortirano po veličini." },
    ],
    extraFaq: [
      {
        q: "Da li perete i obojene stolnjake?",
        a: "Da. Obojeni program peremo odvojeno, uz zaštitu boje i strukture tkanine kroz kontrolisane programe pranja.",
      },
      {
        q: "Možete li pokriti vikend i praznike?",
        a: "Da. Za objekte sa pojačanim prometom definišemo poseban raspored preuzimanja i isporuke za vikende.",
      },
    ],
  },
  "peskir-frotir-spa": {
    breadcrumb: "Peškiri i spa tekstil",
    seoIntro:
      "Pranje peškira, frotira i spa tekstila u Beogradu za wellness centre, spa, teretane, salone lepote i hotelska kupatila. Očuvavamo mekoću, higijenski standard i ujednačen kvalitet kroz visokofrekventnu rotaciju inventara.",
    targets: ["Spa centri", "Wellness", "Teretane", "Hoteli", "Saloni lepote"],
    inventory: [
      "Ručnici za ruke i telo",
      "Spa ogrtači i mantili",
      "Kupatilski setovi",
      "Peškiri za ležaje",
      "Podne prostirke i frotir",
    ],
    highlights: [
      { label: "Mekoća", value: "Očuvana" },
      { label: "Higijena", value: "Kontrolisana" },
      { label: "Rotacija", value: "Dnevna" },
    ],
    localSeo:
      "Uslugu pranja peškira i spa tekstila pružamo objektima u Beogradu i okolini — uključujući wellness zone u hotelima, privatne spa centre i fitnes klubove. Logistika je prilagođena visokom dnevnom prometu i sezonskim pikovima.",
    process: [
      { step: "01", title: "Analiza obima", desc: "Procena dnevnog prometa i tipova frotira." },
      { step: "02", title: "Zonsko preuzimanje", desc: "Odvajanje po nameni — spa, kupatilo, tretmani." },
      { step: "03", title: "Dubinsko pranje", desc: "Uklanjanje mirisa, dezinfekcija po standardu." },
      { step: "04", title: "Sortirana isporuka", desc: "Pakovanje po veličini i zoni objekta." },
    ],
    extraFaq: [
      {
        q: "Da li radite sa hotelskim bazenima i saunama?",
        a: "Da. Peremo peškire i ogrtače za bazene, saune i spa zone, uz programe pranja prilagođene visokoj vlažnosti i učestalosti korišćenja.",
      },
      {
        q: "Kako rešavate problem mirisa u frotiru?",
        a: "Koristimo dubinsko pranje i programe koji neutrališu miris bez narušavanja mekoće i upijanja tkanine.",
      },
    ],
  },
  "radne-uniforme": {
    breadcrumb: "Radne uniforme",
    seoIntro:
      "Profesionalno pranje radnih uniformi za restorane, hotele i spa centre u Beogradu — kuvarske jakne, kecelje, konobarska i sobarska odeća. Uklanjanje mrlja od ulja i hrane, očuvanje boje i forme, rotacija kompleta po zaposlenom.",
    targets: ["Restorani", "Hoteli", "Kafići", "Pekare", "Catering"],
    inventory: [
      "Kuvarske jakne i pantalone",
      "Kecelje i kuhinjske kape",
      "Uniforme konobara",
      "Odeća sobarica i recepcije",
      "Tehničko osoblje",
    ],
    highlights: [
      { label: "Mrlje", value: "Tretirane" },
      { label: "Materijali", value: "Svi tipovi" },
      { label: "Rotacija", value: "Po osobi" },
    ],
    localSeo:
      "Pranje uniformi dostupno je poslovnim korisnicima u celom Beogradu. Bilo da vodite restoran u centru, hotel na Novom Beogradu ili kafić u širem centru — organizujemo preuzimanje i isporuku po vašem rasporedu smena.",
    process: [
      { step: "01", title: "Inventar po ulozi", desc: "Katalog uniformi po odeljenjima i veličinama." },
      { step: "02", title: "Pre-tretman mrlja", desc: "Ulje, začini i proteini — pre glavnog pranja." },
      { step: "03", title: "Pranje po materijalu", desc: "Pamuk, poliester i mešavine — odvojeni programi." },
      { step: "04", title: "Peglanje i pakovanje", desc: "Sortirano po zaposlenom ili veličini." },
    ],
    extraFaq: [
      {
        q: "Da li perete i kecelje i kuhinjske kape?",
        a: "Da. Kompletna kuvarska uniforma — jakne, pantalone, kecelje i kape — ide kroz poseban program pranja i tretmana mrlja.",
      },
      {
        q: "Koliko brzo možete vratiti uniforme?",
        a: "Standardni rok je 24 do 48 sati. Za veće timove definišemo rotaciju sa više kompleta po zaposlenom.",
      },
    ],
  },
  "jorgani-prekivaci-cebad": {
    breadcrumb: "Jorgani i ćebad",
    seoIntro:
      "Dubinsko pranje jorgana, prekrivača i ćebadi za hotele, apartmane i pansione u Beogradu. Voluminozan tekstil peremo u industrijskim kapacitetima, sušimo bez gužvanja i vraćamo upakovan u zaštitne navlake.",
    targets: ["Hoteli", "Apartmani", "Pansioni", "Domovi zdravlja", "Wellness"],
    inventory: [
      "Letnji i zimski jorgani",
      "Navlake za jastuke",
      "Prekrivači i deke",
      "Dekorativne ćebade",
      "Zaštitne navlake",
    ],
    highlights: [
      { label: "Kapacitet", value: "Industrijski" },
      { label: "Sušenje", value: "Bez gužvanja" },
      { label: "Plan", value: "Sezonski" },
    ],
    localSeo:
      "Sezonsko i redovno pranje jorgana pružamo smeštajnim objektima u Beogradu i okolini. Planiramo preuzimanje pre sezone, posle pikova ili u fiksnim intervalima — bez zagušenja vašeg skladišta.",
    process: [
      { step: "01", title: "Sezonski plan", desc: "Definišemo obim i termine preuzimanja unapred." },
      { step: "02", title: "Transport", desc: "Voluminozan tekstil u zaštićenom transportu." },
      { step: "03", title: "Dubinsko pranje", desc: "Kontrola alergena, mirisa i punjenja." },
      { step: "04", title: "Pakovanje", desc: "Zaštitne navlake za skladištenje u objektu." },
    ],
    extraFaq: [
      {
        q: "Da li perete dekorativne ćebade i prekrivače?",
        a: "Da. Peremo dekorativni i zaštitni tekstil, uz programe prilagođene materijalu i boji.",
      },
      {
        q: "Kako planirate sezonsko pranje?",
        a: "U proceni definišemo kalendar preuzimanja i vraćanja — posebno pre leta i zime, kada se menja inventar soba.",
      },
    ],
  },
  "rotacija-dostava": {
    breadcrumb: "Rotacija i dostava",
    seoIntro:
      "Organizovana rotacija i dostava tekstila za restorane, hotele i spa centre u Beogradu. TOP WASH DOO preuzima prljav veš i vraća čist inventar po fiksnom rasporedu — dnevno, više puta nedeljno ili po sezonskom planu.",
    targets: ["Restorani", "Hoteli", "Spa centri", "Kafići", "Catering"],
    inventory: [
      "Posteljina i frotir",
      "Stolnjaci i salvete",
      "Uniforme osoblja",
      "Jorgani i prekrivači",
      "Kompletan tekstil objekta",
    ],
    highlights: [
      { label: "Termini", value: "Fiksni" },
      { label: "Zona", value: "Beograd" },
      { label: "Kontakt", value: "Jedan tim" },
    ],
    localSeo:
      "Logistiku rotacije tekstila pokrivamo na teritoriji Beograda — od centra do periferije i poslovnih zona. Jedna kontakt tačka, jasan raspored i pouzdana isporuka u dogovorenom terminu, svake smene.",
    process: [
      { step: "01", title: "Mapa ritma", desc: "Analiziramo smene, sezonu i obim po danu." },
      { step: "02", title: "Raspored", desc: "Fiksni termini preuzimanja i isporuke." },
      { step: "03", title: "Sortiranje", desc: "Prijem prljavog tekstila po kategorijama." },
      { step: "04", title: "Isporuka", desc: "Čist inventar spreman za upotrebu." },
    ],
    extraFaq: [
      {
        q: "Da li rotacija uključuje i pranje?",
        a: "Da. Rotacija je kompletan model — preuzimanje, pranje, peglanje, pakovanje i isporuka čistog tekstila.",
      },
      {
        q: "Kako se prati obim kroz mesec?",
        a: "Mesečni obračun sa jasnim izveštajem — po komadu, kilogramu ili paketu, u zavisnosti od ugovora.",
      },
    ],
  },
};

export function enrichService(service) {
  const details = SERVICE_DETAILS[service.slug];
  if (!details) return service;
  return {
    ...service,
    ...details,
    faq: [...service.faq, ...(details.extraFaq || [])],
  };
}
